import MaterialType from '../types/api/material-type'
import { getMaterialTypes } from './get-material-types'

export function getUniqueMaterials(record: {
    material_type?: MaterialType
    additional_material_types?: MaterialType[]
}) {
    const list = getMaterialTypes(record)

    // На всякий случай убираем дубликаты по documentId
    const byId = new Map<string, MaterialType>()
    for (const m of list) {
        if (!m?.documentId) continue
        byId.set(m.documentId, m)
    }

    return [...byId.values()]
}
